/**
 * External dependencies
 */
import { registerCheckoutBlock } from '@woocommerce/blocks-checkout';
import { withFilteredAttributes } from '@woocommerce/shared-hocs';
/**
 * Internal dependencies
 */
import Block from './block';
import metadata from './block.json';
import attributes from './attributes';

registerCheckoutBlock({
	metadata,
	component: withFilteredAttributes( attributes )( Block ),
});
